import { Theme } from '@/theme';
import styled from 'styled-components';

export const ContentContainer = styled.div`
  margin-bottom: 16px;
  text-align: center;
`;

export const ConfirmTitle = styled.h3`
  font-family: ${Theme.font.family.speedeeCondensed};
  font-size: ${Theme.rems(40)};
  text-transform: uppercase;
  margin-bottom: 8px;
`;

export const ConfirmMessage = styled.p`
  font-size: ${Theme.rems(16)};
  line-height: 140%;
`;

export const ButtonsContainer = styled.div`
  position: relative;

  button {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
